import { PaxTypeCode } from 'gql/autogen/PaxTypeCode';
import { parseISO } from 'date-fns';
import { ContinueYourBookingActivity } from 'component/page/home/ContinueYourBooking/ContinueYourBooking.types';

const MockActivityContentMetaInfo: ContinueYourBookingActivity[] = [
    {
        cityId: 9395,
        activityId: 1041430,
        activityTitle: 'King Power Mahanakhon SkyWalk Ticket | Bangkok',
        activityImage: 'https://image.kkday.com/v2/image/get/w_1920,h_1080,c_fit,q_55,wm_auto/s1.kkday.com/product_20739/20181128022636_HR24w/jpg',
        pax: [
            {
                paxType: PaxTypeCode.TICKET,
                quantity: 22,
            },
        ],
        travelDate: parseISO('2025-01-06'),
        enrichedOfferId: 1350618,
        offerOptionId: 0,
    },
    {
        cityId: 9395,
        activityId: 1052544,
        activityTitle: 'SENSE OF THAI Costume Rental Experience | Bangkok',
        activityImage: 'https://image.kkday.com/v2/image/get/w_1920,h_1080,c_fit,q_55,wm_auto/s1.kkday.com/product_32106/20230606114906_WZHDW/png',
        pax: [
            {
                paxType: PaxTypeCode.TICKET,
                quantity: 2,
            },
        ],
        travelDate: parseISO('2026-01-01'),
        enrichedOfferId: 459168,
        offerOptionId: 0,
    },
    {
        cityId: 9395,
        activityId: 1262344,
        activityTitle: 'Mahanakhon SkyWalk Observation Deck Ticket',
        activityImage: 'https://pix6.agoda.net/generic/1e4a0f17a91ff0320ad28edf9aac476e.jpeg?ce=0',
        pax: [
            {
                paxType: PaxTypeCode.ADULT,
                quantity: 2,
            },
            {
                paxType: PaxTypeCode.SENIOR,
                quantity: 3,
            },
            {
                paxType: PaxTypeCode.CHILD,
                quantity: 1,
            },
        ],
        travelDate: parseISO('2025-06-06'),
        enrichedOfferId: 1590138,
        offerOptionId: 0,
    },
    {
        cityId: 16056,
        activityId: 846157,
        activityTitle: 'Phuket Private Instagram Tour: All-Inclusive',
        activityImage: 'https://pix6.agoda.net/generic/1e4a0f17a91ff0320ad28edf9aac476e.jpeg?ce=0',
        pax: [
            {
                paxType: PaxTypeCode.ADULT,
                quantity: 2,
            },
            {
                paxType: PaxTypeCode.SENIOR,
                quantity: 3,
            },
            {
                paxType: PaxTypeCode.CHILD,
                quantity: 1,
            },
        ],
        travelDate: parseISO('2025-03-02'),
        enrichedOfferId: 1590139,
        offerOptionId: 0,
    },
    {
        cityId: 16808,
        activityId: 1012645,
        activityTitle: 'At a glance',
        activityImage: 'https://media-cdn.tripadvisor.com/media/attractions-splice-spp-720x480/12/61/20/d4.jpg',
        pax: [
            {
                paxType: PaxTypeCode.ADULT,
                quantity: 2,
            },
            {
                paxType: PaxTypeCode.SENIOR,
                quantity: 3,
            },
            {
                paxType: PaxTypeCode.CHILD,
                quantity: 1,
            },
        ],
        travelDate: parseISO('2025-02-24'),
        enrichedOfferId: 944018,
        offerOptionId: 8,
    },
];

export default MockActivityContentMetaInfo;
